import React, {ReactElement} from "react";
import Topbar from "../Topbar";

export default function Page({children}: { children: ReactElement }): ReactElement {
	return (
			<React.Fragment>
				<Topbar/>
				<div className="page">
					{children}
				</div>
			</React.Fragment>
	)
}